import { grantPermissionsToOrganisation } from '@infuse/api/iam/organisation';
import { useGenericGrantPermission } from '@infuse/iam/permission/mutations';

export const useGrantPermissionToOrganisation = () => {
  return useGenericGrantPermission({
    apiFn: grantPermissionsToOrganisation
  });
};
